<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        cart: {
            type: Object,
            required: true,
            default: [],
        },
    },

    data() {
        return {
            itemAdded: null,
        };
    },

    computed: {
        ...mapGetters('cart', ['items', 'count', 'totalPrice', 'hasBeenInitiated']),
    },

    watch: {
        count() {
            if (!this.hasBeenInitiated) {
                return;
            }

            this.$emit('updated');
        },
    },

    methods: {
        ...mapActions('cart', ['initateCart']),
    },

    mounted() {
        let cartId = document.head.querySelector('meta[name="cart-id"]');

        if (!cartId) {
            return console.error(
                'Cart ID not found: https://docs.hlxdev.com/lego/frontend/layouts#cart-id'
            );
        }

        this.initateCart({
            id: cartId.content,
            items: this.cart.items,
            currency: this.$data._currency || 'USD',
            locale: this.$data._locale || 'en',
            couponCode: this.cart.couponCode,
        });
    },

    render() {
        return this.$scopedSlots.default({
            count: this.count,
        });
    },
};
</script>
